import moment from 'moment'
import Vue from 'vue'

Vue.filter('date', input => {
  if (typeof input === 'undefined' || input === '') {
    return ''
  }
  let date = moment(input)
  if (moment().isSame(date, 'day')) {
    return 'Today at ' + date.format('HH:mm')
  } else {
    return date.format('ddd, D MMMM [at] HH:mm')
  }
})
Vue.filter('deldate', input => {
  if (typeof input === 'undefined' || input === '') {
    return ''
  }
  let date = moment(input)
  return date.format('ddd, D MMMM YYYY')
})
Vue.filter('formatAddress', input => {
  if (typeof input === 'undefined') {
    return ''
  }
  if (typeof input.street_number !== 'undefined') {
    return input.street_number + ' ' + input.route + ', ' + input.sublocality + ', ' + input.locality
  }
  return input.route + ', ' + input.locality
})
Vue.filter('formatShortAddress', input => {
  if (typeof input === 'undefined') {
    return ''
  }
  if (typeof input.street_number !== 'undefined') {
    return input.street_number + ' ' + input.route
  }
  return input.route + ', ' + input.locality
})
Vue.filter('formatOrdernumber', input => {
  if (typeof input === 'undefined' || input === '') {
    return ''
  }
  return '#' + String(input).padStart(6, '0')
})
Vue.filter('formatPaymentMethod', input => {
  switch (input) {
    case 'Credit Card':
      return 'Credit / Debit Card'
    case 'Cash on Delivery':
      return 'Pay on Collect / Delivery'
  }
  return input
})
